import Adobe from "../providers/adobe";
import Facebook from "../providers/facebook";
import Google from "../providers/google";
import * as MUTATIONS from "../../config/constants/mutation-types";

const pixelDb = {
  triggers: {
    [MUTATIONS.ON_ROUTE]: {
      paso1: ["Adobe.paso1", "Facebook.paso1", "Google.paso1"],
      paso2: ["Adobe.paso2", "Facebook.paso2", "Google.paso2"],
      resumen: ["Adobe.resumen", "Facebook.resumen", "Google.resumen"],
      condicion: ["Adobe.condicion", "Facebook.condicion", "Google.condicion"],
      marca: ["Adobe.marca", "Facebook.marca", "Google.marca"],
      modelo: ["Adobe.modelo", "Facebook.modelo", "Google.modelo"],
      version: ["Adobe.version", "Facebook.version", "Google.version"],
      gnc: ["Adobe.gnc", "Facebook.gnc", "Google.gnc"],
      guardado: ["Adobe.guardado", "Facebook.guardado", "Google.guardado"],
      cotizacion_planes: [
        "Adobe.cotizacion_planes",
        "Facebook.cotizacion_planes",
        "Google.cotizacion_planes"
      ],
      mensaje: ["Adobe.errorPage"],
      loading: ["Adobe.verificacion"]
    },
    [MUTATIONS.ADOBE_INTERNAL_LINK]: ["Adobe.internalLink"],
    [MUTATIONS.ADOBE_QUIERO_QUE_ME_CONTACTEN]: ["Adobe.quieroquemecontacten"],
    [MUTATIONS.ADOBE_APP_STARTED]: ["Adobe.appStarted"],
    [MUTATIONS.ADOBE_APP_ON_CLICK_START]: ["Adobe.appOnClickStart"]
  },
  providers: {
    Adobe,
    Facebook,
    Google
  }
};

export default pixelDb;
